import type { TIME_FORMAT_MONTH_DATE_YEAR, TIME_FORMAT_NUMERICAL_SHORT } from '@/datetime/dateTime.utilities';

export enum RelativeDateRangeUnit {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export interface RelativeDateRangeSelection {
  amount: number;
  unit: RelativeDateRangeUnit;
}

/**
 * A range that starts on a calendar boundary rather than a fixed duration ago: from the start of the current day
 * (`today`) or year (`yearToDate`) in a time zone, up to now.
 */
export type CalendarDateRange = 'today' | 'yearToDate';

/** A range that rolls forward with the current time: a relative duration or a calendar range. */
export type DateRangePreset =
  | { kind: 'relative'; relativeDateRangeSelection: RelativeDateRangeSelection }
  | { kind: 'calendar'; calendarRange: CalendarDateRange };

/** What a date range filter has selected: a preset that is re-resolved against the current time, or fixed dates. */
export type DateRangeSelection = DateRangePreset | { kind: 'fixed' };

export interface QuickDateRange {
  id: string;
  /** Translation key */
  label: string;
  preset: DateRangePreset;
}

export type DisplayDateTimeFormat = typeof TIME_FORMAT_NUMERICAL_SHORT | typeof TIME_FORMAT_MONTH_DATE_YEAR;
